import { ObjectMode } from '@databases/types';
import { Content, ContentType } from '@databases/types/confluence';

import { createContent } from './content';

export async function createPage(
  page: Omit<Content<ContentType, ObjectMode.CREATE>, 'type'>,
  expand: string[] = []
): Promise<Content<'page'>> {
  return await createContent<'page'>(
    {
      type: 'page',
      ...page,
    },
    expand
  );
}

/**
 * Create a page, avoiding title conflicts by retrying with different suffixes.
 */
export async function createNonConflictingPage(
  page: Omit<Content<ContentType, ObjectMode.CREATE>, 'type'>,
  expand: string[] = []
): Promise<Content> {
  // eslint-disable-next-line no-constant-condition
  for (let i = 0; true; i++) {
    // eslint-disable-line no-constant-condition
    const thisTitle = i === 0 ? page.title : `${page.title} (${i + 1})`;

    try {
      return await createPage({ ...page, title: thisTitle }, expand);
    } catch (e: any) {
      if (!e.message.includes('already exists') || i > 20) {
        throw e;
      }
    }
  }
}
